var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "10px",
    viewBox: "0 0 20 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "44_My-playlist",
    transform: "translate(-201, -434)",
    fill: "#2363F7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-41, -49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_arrow",
    transform: "translate(242, 483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.86781,4.68115121 L19.86781,4.68115121 L15.3224613,0.158108357 C15.159183,-0.0316150299 14.8722349,-0.0537319337 14.6815743,0.108782608 C14.4909136,0.271258281 14.4686874,0.55679567 14.6320048,0.746519057 C14.647239,0.764204806 14.6638012,0.780724462 14.6815743,0.795844805 L18.4496712,4.54996571 L0.454523149,4.54996571 C0.203511998,4.54996571 0,4.75247725 0,5.00229332 C0,5.25210938 0.203511998,5.45458205 0.454523149,5.45458205 L18.4496712,5.45458205 L14.6815743,9.20415519 C14.4909136,9.36663087 14.4686874,9.65216826 14.6320048,9.84189164 C14.7953223,10.031615 15.0822312,10.0537319 15.2728919,9.89121739 C15.290665,9.87605818 15.3072663,9.85957739 15.3224613,9.84189164 L19.867849,5.31884879 C20.0440568,5.14249661 20.0440568,4.85758113 19.86781,4.68115121 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlue);
export default __webpack_public_path__ + "static/media/arrow_blue.456ffb1a69dc3eb9801efb21138ac912.svg";
export { ForwardRef as ReactComponent };